export const LEADERSHIP_STATUS_OPTIONS = [
  { value: "Open", label: "Open" },
  { value: "Closed", label: "Closed" },
] 
export const LEADERSHIP_PAGE_SIZE = 10;
